module.exports = __webpack_public_path__ + "static/media/IndoorSandCourt2Balls.081077c7.jpg";